<template>
  <div class="index">
    <div class="banner" style="cursor: pointer;">
      <!-- <img src="../assets/img/banner.png" class="img-responsive" > -->
      <swiper :options="swiperOption" class="swiper-container" ref="mySwiper">
        <swiper-slide class="swiper-slide" v-for="(item, index) in bannerList" :key="index"><img :src="item.coverImage"
            style="width: 100%;" /></swiper-slide>

        <div class="swiper-pagination" slot="pagination"></div>
      </swiper>
    </div>
    <div class="container">
      <div class="flex" style="justify-content: space-between;margin-top: 20px;">
        <div class="history flex1" @click="handleHistory()">
          <div>
            <img src="../assets/img/history1.png" />
            <div class="aui-text-white" style="color: #fff;font-size: 26px;margin-top: 5px;">
              历年真题
            </div>
          </div>
        </div>
        <div class="space"></div>
        <div class="moni flex1" @click="handleTest()">
          <div>
            <img src="../assets/img/moni1.png" />
            <div class="" style="color: #fff;font-size: 26px;margin-top: 5px;">
              模拟考试
            </div>
          </div>
        </div>
        <div class="space"></div>
        <div class="after flex1" @click="handleHomeWork()">
          <div>
            <img src="../assets/img/after.png" />
            <div class="" style="color: #fff;font-size: 26px;margin-top: 5px;">
              章节练习
            </div>
          </div>
        </div>
      </div>
      <div class="flex" style="justify-content: space-between;margin-top: 20px;">
        <div class="history flex1" style="background-color: #c57efe;" @click="handleTraining()">
          <div>
            <img src="../assets/img/history1.png" />
            <div class="aui-text-white" style="color: #fff;font-size: 26px;margin-top: 5px;">
              阶段测试
            </div>
          </div>
        </div>
        <div class="space"></div>
        <div class="moni flex1" style="background-color: #37da52;" @click="handleBefore()">
          <div>
            <img src="../assets/img/moni1.png" />
            <div class="" style="color: #fff;font-size: 26px;margin-top: 5px;">
              考前押题
            </div>
          </div>
        </div>
        <div class="space"></div>
        <div class="after flex1" style="background-color: #f67754;" @click="handleError">
          <div>
            <img src="../assets/img/after.png" />
            <div class="" style="color: #fff;font-size: 26px;margin-top: 5px;">
              错题收藏
            </div>
          </div>
        </div>
        <div class="space"></div>
        <div class="after flex1" style="background-color: #fbaa4c;" @click="handleTeacherAnswer">
          <div>
            <img src="../assets/img/after.png" />
            <div class="" style="color: #fff;font-size: 26px;margin-top: 5px;">
              老师答疑
            </div>
          </div>
        </div>
      </div>
      <!-- 		<div class="flex" style="justify-content: space-between;text-align: center;padding: 15px 0;">

				<div class="flexitem" @click="handleHomeWork()">
					<img src="../assets/img/homelist_1.png" />
					<div>历年真题</div>
				</div>
				<div class="flexitem" @click="handleTest()">
					<img src="../assets/img/homelist_2.png" />
					<div>模拟考试</div>
				</div>
				<div class="flexitem" @click="handleHomeWork()">
					<img src="../assets/img/homelist_3.png" />
					<div>课后练习</div>
				</div>
				<div class="flexitem" @click="handleTraining()">
					<img src="../assets/img/homelist_4.png" />
					<div>综合通关</div>
				</div>
				<div class="flexitem" @click="handleBefore()">
					<img src="../assets/img/homelist_5.png" />
					<div>考前押题</div>
				</div>
				<div class="flexitem" @click="handleError">
					<img src="../assets/img/homelist_6.png" />
					<div>错题收藏</div>
				</div>
				<div class="flexitem" @click="handleTeacherAnswer">
					<img src="../assets/img/homelist_7.png" />
					<div>老师答疑</div>
				</div>
			</div> -->
    </div>
    <div class="pro-wrapper">
      <div class="pro-bar clearfix">
        <span class="pro-title">考试资讯</span><a data-v-634a12ac="" href="/news/0" class="pro-more"
          style="display: none;">more</a>
      </div>
      <div class="pro-message clearfix">
        <div class="pro-message-left">
          <div class="pro-message-banner">
            <img src="http://www.psschool.net/img/news-default.5cdeb31d.png" />
          </div>
        </div>
        <div class="pro-message-right">
          <ul class="pro-message-list">
            <li v-for="item in newList" @click="handleNewsDetail(item.newsId)">
              <a style="cursor: pointer;" class=""><span>•</span> {{ item.newsTitle }}
              </a>
            </li>
          </ul>
        </div>
      </div>
    </div>
    <div class="pro-container">
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">在职考证类</span><a @click="handleMoreVocational(1)" class="pro-more"
            style="cursor: pointer;">more</a>
        </div>
        <ul class="pro-product-label clearfix">
          <li v-for="(item, index) in kaoyanCategoryList" @click="
            examGraduateStudentCategoryId = item.examGraduateStudentCategoryId
          " :key="index">
            <span :class="{
              active:
                examGraduateStudentCategoryId ==
                item.examGraduateStudentCategoryId
            }">{{ item.categoryName }}</span>
          </li>
        </ul>
        <div class="pro-product-body clearfix">
          <div class="float-left">
            <div class="pro-product-banner">
              <a class=""><img :src="kaoyancover" @click="handleOpenUrl(kaoyancoverUrl)" /></a>
            </div>
          </div>
          <div class="float-right">
            <ul class="pro-product-list clearfix">
              <li v-for="item in examGraduateStudentList">
                <a :href="item.examGraduateStudentUrl" target="_blank" class="">
                  <!---->
                  <div class="hot-product-img">
                    <!----><img :data-src="item.examGraduateStudentCoverImage" :src="item.examGraduateStudentCoverImage"
                      lazy="loaded" />
                  </div>
                  <h3 class="hot-product-title">
                    {{ item.examGraduateStudentTitle }}
                  </h3>
                  <span data-v-634a12ac="" class="hot-product-type">【{{ item.examGraduateStudentSubTitle }}】</span><span
                    data-v-634a12ac="" class="hot-product-price"><span data-v-634a12ac="">￥{{
                        item.examGraduateStudentPrice
                    }}</span><s
                      style="margin-left: 8px; color: rgb(128, 128, 128); font-weight: normal; font-size: 12px; display: none;">￥-1</s></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pro-container">
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">在职考研类</span><a class="pro-more" style="cursor: pointer;"
            @click="handleMoreVocational(2)">more</a>
        </div>
        <ul class="pro-product-label clearfix">
          <li v-for="item in vocationalExamCategory" @click="vocationalExamCategoryId = item.vocationalExamCategoryId">
            <span :class="{
              active:
                vocationalExamCategoryId == item.vocationalExamCategoryId
            }">{{ item.categoryName }}</span>
          </li>
        </ul>
        <div class="pro-product-body clearfix">
          <div class="float-right">
            <div class="pro-product-banner">
              <a class=""><img :src="zhiyecover"  @click="handleOpenUrl(zhiyecoverUrl)"  /></a>
            </div>
          </div>
          <div class="float-left">
            <ul class="pro-product-list clearfix">
              <li v-for="item in vocationalExamList">
                <a :href="item.vocationalExamUrl" target="_blank" class="">
                  <!---->
                  <div class="hot-product-img">
                    <!----><img :data-src="item.vocationalExamCoverImage" :src="item.vocationalExamCoverImage"
                      lazy="loaded" />
                  </div>
                  <h3 class="hot-product-title">
                    {{ item.vocationalExamTitle }}
                  </h3>
                  <span class="hot-product-type">【{{ item.vocationalExamSubTitle }}】</span><span
                    class="hot-product-price"><span>￥{{ item.vocationalExamPrice }}</span><s data-v-634a12ac=""
                      style="margin-left: 8px; color: rgb(128, 128, 128); font-weight: normal; font-size: 12px; display: none;">￥-1</s></span>
                </a>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <div class="pro-container">
      <div class="pro-wrapper">
        <div class="pro-bar clearfix">
          <span class="pro-title">精彩展示</span><a style="cursor: pointer;" class="pro-more" @click="handleMorePic">more</a>
        </div>
        <ul class="pro-product-label clearfix">
          <li v-for="item in picCategoryList">
            <span class="" :class="{ active: item.picturesCategoryId == picturesCategoryId }"
              @click="picturesCategoryId = item.picturesCategoryId">{{ item.categoryName }}</span>
          </li>
        </ul>
        <div class="pro-product-body clearfix">
          <div class="">
            <ul class="imglist clearfix"" v-if="picList.length > 0">
              <li v-for="item in picList">
                <a class="">
                  <!---->
                  <div class="hot-product-img" style="height:100%">
                    <!----><img :data-src="item.picturesImage" :src="item.picturesImage" lazy="loaded"
                      style="height:100%;width:auto" />
                  </div>
                  <!-- <h3 class="hot-product-title">{{ item.picturesTitle }}</h3>
                  <span class="hot-product-type"
                    >【{{ item.picturesSubTitle }}】</span> -->
                </a>
              </li>
              <li v-for="item in 4-(picList.length%4)"></li>
            </ul>
          </div>
        </div>
      </div>
    </div>
    <!--  	<div class="listWrap">
  				<div class="list" v-for="item in clist">
  					<div class="container flex">
  						<div class="content">
  							<div class="title">
  								{{item.categoryName}}
  							</div>
  							<div class="smallTitle">
                  <template v-for="voo,index in item.childCategoryList">
                    <span v-if="index<item.childCategoryList.length-1">{{voo.categoryName}},</span>
                     <span v-else>{{voo.categoryName}}</span>
                  </template>

  							</div>
  							<div class="des">
                    {{item.description}}
  							</div>
  							<div class="btnlist">
  								<span style="cursor: pointer;" @click="handleChoose(item.categoryId,item.categoryName)">免费试用</span>
  								<span style="cursor: pointer;" @click="handleDetail(item.categoryId)">产品介绍</span>
  							</div>
  						</div>
  						<div class="cover">
  							<img :src="item.categoryCode" >
  						</div>
  					</div>
  				</div>

  	</div> -->
  </div>
</template>

<script>
var vm;
import "../assets/css/swiper.css";
import bus from "../assets/utils/eventBus.js";
export default {
  name: "Footer",
  components: {},
  data () {
    return {
      swiperOption: {
        pagination: {
          el: ".swiper-container .swiper-pagination",
          clickable: true // 允许点击小圆点跳转,
        },
        autoplay: {
          delay: 3000,
          disableOnInteraction: false // 手动切换之后继续自动轮播
        },
        loop: false,
        navigation: {
          nextEl: ".swiper-button-next",
          prevEl: ".swiper-button-prev"
        },
        on: {
          click: function (e) {
            var activeIndex = vm.$refs.mySwiper.$swiper.activeIndex;
            var obj = vm.bannerList[activeIndex];
            if (obj.url) {
              if (obj.url == "widget://html/message/messageDetails.html") {
                vm.$router.push({
                  path: "newsdetail?newsId=" + obj.primaryId
                });
              }
            }
          }
        }
      },
      bannerList: [],
      clist: [],
      picCategoryList: [], //图集分类
      picturesCategoryId: -1, //图集分类id
      picList: [], //图集
      zhiyecover: "",
      kaoyancover: "",
      kaoyancoverUrl:'',
      zhiyecoverUrl:'',
      kaoyanCategoryList: [],
      examGraduateStudentCategoryId: -1,
      examGraduateStudentList: [],
      vocationalExamCategory: [],
      vocationalExamCategoryId: -1,
      vocationalExamList: [],
      newList: []
    };
  },
  methods: {
    handleOpenUrl(url){
      if(url){
        window.open(url)
      }
    },
    handleNewsDetail (newsId) {
      this.$router.push({ path: "newsdetail?newsId=" + newsId });
    },
    getNewsList () {
      let data = new FormData();
      data.append("pageNo", 1);
      data.append("pageSize", 9);
      // data.append('classify',this.id);
      this.$axios.post(this.$common.news_list, data).then(res => {
        if (res.data.code == 1) {
          this.newList = res.data.data.list;
        } else {
          alert(res.data.msg);
        }
      });
    },
    handleHomeWork () {
      //课后练习
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("homeworklist");
    },
    handleTraining () {
      //综合专训
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("training");
    },
    handleHighfrequency () {
      //高频考点
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("highfrequency");
    },
    handleDouble () {
      //二二密训
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("double");
    },
    handleHistory () {
      //历年真题
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("history");
    },
    handleTest () {
      //模拟考试
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("examination");
    },
    handleBefore () {
      //靠前押题
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("beforeexamination");
    },
    handleError () {
      //错题收藏
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("errorcollect");
    },
    handleTeacherAnswer () {
      // 老师答疑
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push("teacheranswers");
    },
    handleMoreVocational (type) {
      this.$router.push({
        path: "/productlist?type=" + type
      });
    },
    handleMorePic () {
      this.$router.push({
        path: "/piclist"
      });
    },
    handleDetail (id) {
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push({
        path: "/courseDetail?id=" + id
      });
    },
    handleChoose (id, categoryName) {
      if (!window.sessionStorage.token) {
        bus.$emit("login");
        return;
      }
      this.$router.push({
        path: "/choose?id=" + id + "&categoryName=" + categoryName
      });
    },
    getBanner () {
      this.$axios
        .get(this.$common.banners_bannersList + "?modelId=9")
        .then(res => {
          this.bannerList = res.data.data;
        });
    },
    getPicCategory () {
      this.$axios.get(this.$common.pictures_picturesCategoryList).then(res => {
        //   this.bannerList=res.data.data;
        this.picCategoryList = res.data.data.list;
        if (res.data.data.list.length > 0) {
          //	this.picturesCategoryId=res.data.data.list[0].picturesCategoryId
        }
      });
    },
    getKaoyanCategory () {
      this.$axios
        .get(this.$common.vocationalExam_examGraduateStudentCategoryList)
        .then(res => {
          //   this.bannerList=res.data.data;
          this.kaoyanCategoryList = res.data.data.list;
        });
    },
    getexamGraduateStudentList () {
      this.$axios
        .get(
          this.$common.examGraduateStudent_examGraduateStudentList +
          "?examGraduateStudentCategoryId=" +
          this.examGraduateStudentCategoryId +
          "&pageSize=6"
        )
        .then(res => {
          this.examGraduateStudentList = res.data.data.list;
        });
    },
    getvocationalExamCategory () {
      this.$axios
        .get(this.$common.vocationalExam_vocationalExamCategoryList)
        .then(res => {
          this.vocationalExamCategory = res.data.data.list;
        });
    },
    getvocationalExamList () {
      this.$axios
        .get(
          this.$common.vocationalExam_vocationalExamList +
          "?vocationalExamCategoryId=" +
          this.vocationalExamCategoryId +
          "&pageSize=6"
        )
        .then(res => {
          this.vocationalExamList = res.data.data.list;
        });
    },
    getPicList () {
      this.$axios
        .get(
          this.$common.pictures_pictureList +
          "?picturesCategoryId=" +
          this.picturesCategoryId +
          "&pageSize=4"
        )
        .then(res => {
          this.picList = res.data.data.list;
        });
    },
    getPcCoverById (id, type) {
      this.$axios
        .get(this.$common.pcCover_getPcCoverById + "?pcCoverId=" + id)
        .then(res => {
          if (type == 1) {
            this.kaoyancover = res.data.data.coverImage;
            this.kaoyancoverUrl=res.data.data.coverUrl
          } else {
            this.zhiyecover = res.data.data.coverImage;
             this.zhiyecoverUrl=res.data.data.coverUrl
          }

          //this.picList=res.data.data.list;
        });
    }
  },
  created () {
    this.getNewsList();
    this.getBanner();
    // this.getList();
    this.getPicCategory();
    this.picturesCategoryId = "1545323352539926528";
    this.examGraduateStudentCategoryId = "";
    this.vocationalExamCategoryId = "";
    this.getKaoyanCategory();
    this.getvocationalExamCategory();
    this.getPcCoverById("1545312899982036992", 1);
    this.getPcCoverById("1545314470300094464", 2);
    vm = this;
  },
  watch: {
    picturesCategoryId () {
      this.getPicList();
    },
    examGraduateStudentCategoryId () {
      this.getexamGraduateStudentList();
    },
    vocationalExamCategoryId () {
      this.getvocationalExamList();
    }
  }
};
</script>

<style>
.banner {}

.pro-wrapper {
  width: 1200px;
  margin: 0 auto;
}

.pro-wrapper .pro-bar {
  padding: 20px 30px;
  border-bottom: 1px solid #ccc;
}

.pro-message {
  padding-bottom: 40px;
}

.pro-wrapper .pro-bar .pro-title {
  font-size: 26px;
  font-weight: 700;
  letter-spacing: 0.2rem;
}

.pro-wrapper .pro-bar .pro-more {
  font-size: 1.8rem;
  float: right;
  margin-top: 15px;
}

.clearfix:after {
  content: "";
  display: block;
  clear: both;
}

.pro-message .pro-message-left {
  float: left;
  width: 580px;
}

.pro-message .pro-message-right {
  float: left;
  width: 580px;
  margin-left: 40px;
}

.pro-message .pro-message-left .pro-message-banner {
  width: 560px;
  height: 320px;
  margin: 25px 10px 10px 10px;
  border-radius: 10px;
  overflow: hidden;
}

.pro-message .pro-message-left .pro-message-banner img {
  width: 100%;
  height: 100%;
}

.pro-message .pro-message-right .pro-message-list {
  width: 560px;
  margin: 0 auto;
  padding-top: 30px;
}

li,
ol,
ul {
  list-style: none;
}

.pro-message .pro-message-right .pro-message-list li a {
  display: block;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
  height: 35px;
  line-height: 35px;
  font-size: 14px;
  text-decoration: none;
}

.pro-message .pro-message-right .pro-message-list li a span {
  font-size: 30px;
  vertical-align: middle;
  margin-right: 10px;
  color: #666;
}

.pro-wrapper .pro-bar .pro-more {
  font-size: 16px;
  float: right;
  margin-top: 15px;
}

.pro-product-label {
  padding: 10px;
}

.pro-product-label>li {
  float: left;
  position: relative;
  padding: 10px 0;
  width: auto;
  margin: 0 15px;
  text-align: center;
  border-bottom: 3px solid transparent;
}

.pro-product-label>li>span {
  display: block;
  font-size: 18px;
  font-weight: 700;
  width: auto;
  height: 21px;
  /* overflow: hidden; */
  cursor: pointer;
}

.pro-product-label>li>span.active {
  color: red;
}

.pro-product-body {
  padding-top: 10px;
}

.pro-product-body .float-left {
  float: left;
}

.pro-product-body .pro-product-banner {
  width: 260px;
  height: 460px;
  margin: 0 20px;
  border-radius: 10px;
  overflow: hidden;
}

.pro-product-body .pro-product-banner img {
  width: 100%;
}

.pro-product-body .float-right {
  float: right;
}

.pro-product-body .pro-product-list {
  width: 900px;
}

.pro-product-body .pro-product-list li {
  float: left;
  width: 260px;
  height: 210px;
  margin: 0 20px 40px 20px;
  border-radius: 10px;
  overflow: hidden;
  box-shadow: 1px 1px 5px #ccc;
  background-color: #fff;
  position: relative;
}

.pro-product-body .pro-product-list li .hot-product-img {
  position: relative;
  width: 100%;
  height: 130px;
  overflow: hidden;
}

.pro-product-body .pro-product-list li .hot-product-img img {
  width: 100%;
}

.pro-product-body .pro-product-list li .hot-product-title {
  padding: 0 5px;
  height: 50px;
  line-height: 50px;
  color: #333;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.pro-product-body .pro-product-list li .hot-product-type {
  color: #999;
  font-size: 14px;
}

.pro-product-body .pro-product-list li .hot-product-price span {
  float: right;
  color: #ff6600;
  margin-right: 10px;
  margin-top: 2px;
  font-weight: 700;
  font-size: 13px;
}

a {
  text-decoration: none !important;
}

.flexitem {
  cursor: pointer;
}

.space {
  width: 20px;
}

.history {
  background-color: #f98458;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.moni {
  background-color: #6eb4f2;
  text-align: center;
  color: #fff;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}

.after {
  background-color: #58d7bc;
  text-align: center;
  color: #fff;
  padding: 100px 0;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
}
.imglist {
  display: flex;
  flex-wrap: wrap;
  justify-content:  space-between;
  margin-bottom: 20px;
}
.imglist li {
  width: calc((100% - 60px)/4) !important;
}
.imglist li a,.imglist li a img {
  width: 100% !important;
  height: 200px !important;
  object-fit: cover;
}
</style>



// WEBPACK FOOTER //
// src/components/home.vue